import React, { Fragment, useEffect, useState } from "react";

import { Collapse } from "react-bootstrap";
import { checkEmpty } from "services/utils/commonFunctions/CommonFunctions";
import "./FormAccordion.scss";

const FormAccordion = ({
  children,
  subClass,
  activeTab,
  handleTabSelection,
  title,
  status,
  subtitle,
  subheading,
  onClick,
  isLoading = false,
  heightCss = false,
  search = false,
  inputSearch = null,
  filterSearch = null,
  sortBy = null,
  editDetais = null,
  isCheck = null,
  assignToButton = null,
  imageName = null,
  rowMax = true,
  salesButton = null,
  historybtn = false,
  collapse = true,
  rerunBtn = false,
  
}) => {
  const [isCollapsed, setIsCollapsed] = useState(true);
  const [isCollapsedApi, setIsCollapsedApi] = useState(false);
  useEffect(() => {
    activeTab == title ? setIsCollapsed(false) : setIsCollapsed(true);
  }, [activeTab]);
  useEffect(() => {
    if (!collapse) {
      setIsCollapsed(false);
    }
  }, [collapse]);
  return (
    <Fragment>
      <div
        className={`${heightCss ? "panel-card cardpane " : "panel-card"} ${
          subClass ? subClass : ""
        }`}
        aria-hidden="true"
        onClick={onClick}
      >
        {(search || editDetais || title) && (
          <div
            className={`${
              title || search ? "panel-heading" : "col"
            } accordion-btn ${isCollapsed || isCollapsedApi ? "closed" : "open"}`}
            onClick={handleTabSelection}
          >
            {imageName && <img src={imageName} alt="family image" />}
            {title}
            {search && inputSearch()}
            {search && filterSearch()}
            {search && sortBy()}
            {historybtn && (
              <span style={{ float: "right" }}>
                <button className={"btn btn-xs btn-primary"}>History</button>
              </span>
            )}
            {subtitle && <span className="span">{`(${subtitle})`}</span>}
            {subheading && (
              <span className="subheading mt-3">{subheading}</span>
            )}
          </div>
        )}
        <div
          className={`panel-body ${rowMax ? "row mx-0" : ""} ${
            isCollapsed ? "collapsed" : ""
          }`}
        >
          {children}
        </div>
      </div>
    </Fragment>
  );
};

export default FormAccordion;
